import { createUseStyles, subtract } from '@pushpay/styles';
import { GivingOldTheme } from '@pushpay/theming';
import { headerHeightMobile } from '../header';
export const useStyles = createUseStyles(theme => {
  const isGivingOld = theme.colors['product-color'] === GivingOldTheme.colors['product-color'];
  const headerHoverColor = 'rgba(255, 255, 255, 0.25)';
  const headerFocusColor = 'rgba(255, 255, 255, 0.4)';
  return {
    root: {},
    drawerMobile: {
      top: headerHeightMobile
    },
    avatar: {
      backgroundColor: isGivingOld ? theme.colors['color-background-surface'] : theme.colors['palette-grey-dark-200'],
      color: isGivingOld ? theme.colors['palette-red'] : theme.colors['color-text-inverse'],
      height: theme.SPACING.LARGE,
      width: theme.SPACING.LARGE
    },
    activeAvatar: {
      boxShadow: `0 -5px 0 0 ${theme.colors['product-color']} inset`
    },
    avatarButtonWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: subtract(headerHeightMobile, 1)
    },
    avatarButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.SHAPE.CIRCULAR,
      height: theme.SPACING.XLARGE,
      width: theme.SPACING.XLARGE,
      '&:hover': {
        backgroundColor: isGivingOld ? headerHoverColor : theme.colors['palette-grey-light-300'],
        color: isGivingOld ? theme.colors['palette-white'] : theme.colors['color-text-default']
      },
      '&:focus': {
        backgroundColor: isGivingOld ? headerFocusColor : theme.colors['palette-grey-light-300'],
        color: isGivingOld ? theme.colors['palette-white'] : theme.colors['color-text-default'],
        outline: 'none'
      }
    },
    loggingOut: {
      '&:hover, &:focus': {
        textDecoration: 'none'
      }
    },
    overlay: {
      width: '280px'
    },
    overlayContent: {
      backgroundColor: theme.colors['color-background-surface'],
      display: 'flex',
      flexDirection: 'column',
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        height: '100%',
        maxWidth: '75vw',
        width: '280px'
      }
    }
  };
});